import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { TrueTime } from '../../time/true-time.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class InviteLink extends DataModel {
  static readonly TYPE_ID: string = '4283a6b4763546c8a9fb04c824d97e27';

  public readonly enabled: boolean;
  public readonly creationDate: dayjs.Dayjs;

  constructor(
    public readonly inviteCode: string,
    public readonly inviteUrl: string,
    enabled: boolean | null = null,
    creationDate: dayjs.Dayjs | null = null,
  ) {
    super();

    this.enabled = enabled ?? true;
    this.creationDate = creationDate ?? TrueTime.now();
  }

  get $typeId(): string {
    return InviteLink.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): InviteLink {
    return new InviteLink(
        MapUtils.get<string>(map, 'inviteCode'),
        MapUtils.get<string>(map, 'inviteUrl'),
        MapUtils.getOrNull<boolean>(map, 'enabled'),
        context.decodeDateOrNull(MapUtils.getOrNull<number>(map, 'creationDate')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'inviteCode': this.inviteCode,
      'inviteUrl': this.inviteUrl,
      'enabled': this.enabled,
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return new InviteLink(
        this.inviteCode,
        this.inviteUrl,
        this.enabled,
        TimeZone.cloneDate(this.creationDate),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.inviteCode === this.inviteCode &&
        other.inviteUrl === this.inviteUrl &&
        other.enabled === this.enabled &&
        other.creationDate === this.creationDate;
  }
}

export class InviteLinkBuilder extends DataModelBuilder<InviteLink> {
  build(context: SerializationContext, map: SerializedData): InviteLink {
    return InviteLink.fromMap(context, map);
  }
}
